<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>DREAMS and VISIONS</title><link href="default.css" rel="stylesheet" type="text/css"/>
<p class="tx"><br/><br/><br/><br/></p>
<p class="txc" id="p0011-01-0"><span><i>To Jesus~ </i></span></p>
<p class="txc" id="p0011-02-1"><span><i>You are the King of the Universe and my <br/>savior. How amazing You are! We live in days<br/>of accelerated global transformation and social<br/>unrest, yet You remain the rock of our salvation<br/>and the anchor of our hope.</i></span></p>
<p class="txc45" id="p0011-03-3"><span><i>I love you.</i></span></p>
<p class="txc" id="p0011-03-4"><span><i>“In this world you will have trouble. But take <br/>heart! I have overcome the world.”</i></span></p>
<p class="txc456" id="p0011-04-6"><span><i>John 16:33 </i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter4.vue?182ac760